<abp-page [title]="'Inventory::LegalDocuments' | abpLocalization">
  <abp-page-toolbar-container class="col">
    <div class="text-lg-end pt-2">
      <button
        *abpPermission="'Inventory.LegalDocuments.Create'"
        class="btn btn-primary btn-sm"
        type="button"
        (click)="create()"
      >
        <i class="fa fa-plus me-1" aria-hidden="true"></i>
        {{ 'Inventory::NewLegalDocument' | abpLocalization }}
      </button>
    </div>
  </abp-page-toolbar-container>

  <abp-advanced-entity-filters localizationSourceName="Inventory" [list]="list">
    <abp-advanced-entity-filters-form>
      <form #filterForm (keyup.enter)="list.get()">
        <div class="row">
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="descriptionFilter">
                {{ 'Inventory::Description' | abpLocalization }}
              </label>

              <input
                id="descriptionFilter"
                class="form-control"
                [(ngModel)]="filters.description"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="minExpireDate">
                  {{ 'Inventory::MinExpireDate' | abpLocalization }}
              </label>

              <div class="input-group" validationTarget>
                <input
                  id="minExpireDate"
                  class="form-control"
                  #minExpireDateInput
                  #minExpireDateDatepicker="ngbDatepicker"
                  name="minExpireDate"
                  ngbDatepicker
                  container="body"
                  readonly
                  (click)="minExpireDateDatepicker.toggle()"
                  (keyup.space)="minExpireDateDatepicker.toggle()"
                  [(ngModel)]="filters.expireDateMin"
                  [ngModelOptions]="{ standalone: true }"
                />
                <div *ngIf="minExpireDateInput.value" class="input-group-append">
                  <button
                    class="btn btn-link px-2"
                    type="button"
                    [title]="'AbpUi::Clear' | abpLocalization"
                    (click)="minExpireDateDatepicker.writeValue(null); minExpireDateDatepicker.manualDateChange(null, true)"
                  >
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="maxExpireDate">
                {{ 'Inventory::MaxExpireDate' | abpLocalization }}
              </label>

              <div class="input-group" validationTarget>
                <input
                  id="maxExpireDate"
                  class="form-control"
                  #maxExpireDateInput
                  #maxExpireDateDatepicker="ngbDatepicker"
                  name="maxExpireDate"
                  ngbDatepicker
                  readonly
                  (click)="maxExpireDateDatepicker.toggle()"
                  (keyup.space)="maxExpireDateDatepicker.toggle()"
                  [(ngModel)]="filters.expireDateMax"
                  [ngModelOptions]="{ standalone: true }"
                />
                <div *ngIf="maxExpireDateInput.value" class="input-group-append">
                  <button
                    class="btn btn-link px-2"
                    type="button"
                    [title]="'AbpUi::Clear' | abpLocalization"
                    (click)="maxExpireDateDatepicker.writeValue(null); maxExpireDateDatepicker.manualDateChange(null, true)"
                  >
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-auto align-self-end mb-3">
            <div class="row">
              <div class="col-6 col-sm-auto d-grid">
                <button
                  type="button"
                  class="btn btn-outline-primary"
                  (click)="clearFilters()"
                >
                  <span>{{ 'AbpUi::Clear' | abpLocalization }}</span>
                </button>
              </div>
              <div class="col-6 col-sm-auto d-grid">
                <button type="button" class="btn btn-primary" (click)="list.get()">
                  <span>{{ 'AbpUi::Refresh' | abpLocalization }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </abp-advanced-entity-filters-form>
  </abp-advanced-entity-filters>

  <div class="card">
    <div class="card-body">
      <ngx-datatable [rows]="data.items" [count]="data.totalCount" [list]="list" default>
        <ngx-datatable-column
          [name]="'AbpUi::Actions' | abpLocalization"
          [maxWidth]="150"
          [width]="150"
          [sortable]="false"
        >
          <ng-template let-row="row" let-i="rowIndex" ngx-datatable-cell-template>
            <div ngbDropdown container="body" class="d-inline-block">
              <button
                class="btn btn-primary btn-sm dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                ngbDropdownToggle
              >
                <i class="fa fa-cog me-1" aria-hidden="true"></i>
                {{ 'AbpUi::Actions' | abpLocalization }}
              </button>

              <div ngbDropdownMenu>
                <button
                  ngbDropdownItem
                  *abpPermission="'Inventory.LegalDocuments.Edit'"
                  (click)="update(row)"
                >
                  {{ 'AbpUi::Edit' | abpLocalization }}
                </button>

                <button
                  ngbDropdownItem
                  *abpPermission="'Inventory.LegalDocuments.Delete'"
                  (click)="delete(row)"
                >
                  {{ 'AbpUi::Delete' | abpLocalization }}
                </button>
              </div>
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::Description' | abpLocalization }}" prop="description">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.description }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::ExpireDate' | abpLocalization }}" prop="expireDate">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.expireDate | date }}
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>
  </div>
</abp-page>

<abp-modal [busy]="isModalBusy" [(visible)]="isModalOpen">
  <ng-template #abpHeader>
    <h3>
      {{ (selected ? 'AbpUi::Edit' : 'Inventory::NewLegalDocument') | abpLocalization }}
    </h3>
  </ng-template>

  <ng-template #abpBody>
    <form [formGroup]="form" (ngSubmit)="submitForm()" validateOnSubmit>
      <div class="mt-2 fade-in-top">
        <div class="mb-3">
          <label class="form-label" for="legal-document-description">
            {{ 'Inventory::Description' | abpLocalization }} *
          </label>

          <input
            id="legal-document-description"
            formControlName="description"
            class="form-control"
            autofocus
          />
        </div>
        <div class="mb-3">
          <label class="form-label" for="legal-document-expire-date">
            {{ 'Inventory::ExpireDate' | abpLocalization }} 
          </label>

          <div class="input-group" validationTarget>
            <input
              readonly
              id="legal-document-expire-date"
              formControlName="expireDate"
              class="form-control"
              ngbDatepicker
              #expireDateInput
              #expireDateDatepicker="ngbDatepicker"
              (click)="expireDateDatepicker.open()"
              (keyup.space)="expireDateDatepicker.open()"
            />
            <div *ngIf="expireDateInput.value" class="input-group-append">
              <button
                class="btn btn-link px-2"
                type="button"
                [title]="'AbpUi::Clear' | abpLocalization"
                (click)="expireDateDatepicker.writeValue(null); expireDateDatepicker.manualDateChange(null, true)"
              >
                <i class="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #abpFooter>
    <button type="button" class="btn btn-secondary" abpClose>
      {{ 'AbpUi::Cancel' | abpLocalization }}
    </button>

    <abp-button iconClass="fa fa-check" (click)="submitForm()" [disabled]="form?.invalid">
      {{ 'AbpUi::Save' | abpLocalization }}
    </abp-button>
  </ng-template>
</abp-modal>
